import { useEffect, useMemo } from "react";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { MaquinasequipForm } from "../../../schemas/Maquinasequip_cadastro/Maquinasequip_cadastro";
import { FormMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_masked_input";
import { UseFormReturn } from "react-hook-form";
import { DefaultFormRadioGroupInput } from "../../../../../../common/components/default_form_radio_group_input";
import { DefaultFormDatePickerInput } from "../../../../../../common/components/default_form_date_picker_input";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DefaultFormMoneyInput } from "../../../../../../common/components/default_form_money_input";
import { DefaultFormSelectInput } from "../../../../../../common/components/default_form_select_input";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { DefaultFormCheckBox } from "../../../../../../common/components/default_form_checkbox";

import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";
import dayjs from "dayjs";

type Props = {
  saving: boolean;
  centroCustoDropdown: CentroCustoDropDown[];
  fornecedorDropdown: FornecedorDropDown[];
  funcionarioMonitDropdown: FuncionarioDropDown[];
  funcionarioRespDropdown: FuncionarioDropDown[];
  hookForm: UseFormReturn<MaquinasequipForm>;
};

export const MaquinasequipContent = ({
  saving,
  centroCustoDropdown,
  fornecedorDropdown,
  funcionarioMonitDropdown,
  funcionarioRespDropdown,
  hookForm,
}: Props) => {
  const [
    tipoCalibradoMonit,
    preencherRespCal,
    preencherRespResp,
    frequenciaVerificacao,
    dataVerificacao,
  ] = hookForm.watch([
    "tipoCalibradoMonit",
    "preencherRespCal",
    "preencherRespResp",
    "frequenciaVerificacao",
    "dataVerificacao",
  ]);

  const ativoOptions = useMemo(() => {
    return [
      { id: 1, label: "Sim" },
      { id: 0, label: "Não" },
    ];
  }, [
  ]);

  const tipoOptions = useMemo(() => {
    return [
      { id: 0, label: "Funcionário" },
      { id: 1, label: "Fornecedor" },
      { id: 2, label: "Não se aplica" },
    ];
  }, [
  ]);

  const monitoramentoOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: "Calibrado",
        style: {
          backgroundColor: "#FFD700",
          padding: "5px",
          borderRadius: "4px",
          color: 'black',
          fontWeight: 'bold',
        }
      },
      {
        id: 0,
        label: "Verificação",
        style: {
          backgroundColor: "#00A000",
          padding: "5px",
          borderRadius: "4px",
          color: 'black',
          fontWeight: 'bold',
        }
      },
      {
        id: 2,
        label: "Não se aplica",
        style: {
          backgroundColor: "#c9c9c9",
          padding: "5px",
          borderRadius: "4px",
          color: 'black',
          fontWeight: 'bold',
        }
      },
    ];
  }, [
  ]);

  const fatorGeradorOptions = useMemo(() => {
    return [
      { id: 0, label: "Compra" },
      { id: 1, label: "Doação" },
      { id: 2, label: "Empréstimo" },
      { id: 3, label: "Locação" },
      { id: 4, label: "Desconhecido" },
    ];
  }, [
  ]);

  const statusOptions = useMemo(() => {
    return [
      { id: 0, label: "Novo" },
      { id: 1, label: "Bom Estado" },
      { id: 2, label: "Velho" },
      { id: 3, label: "Sem Condições De Uso" },
    ];
  }, [
  ]);

  useEffect(() => {
    if (!dataVerificacao || !frequenciaVerificacao) {
      hookForm.setValue("dataProxVerificacao", null);
    } else {
      hookForm.setValue("dataProxVerificacao", dayjs(dataVerificacao).add(frequenciaVerificacao, 'day').toDate());
    }
  }, [
    hookForm,
    dataVerificacao,
    frequenciaVerificacao,
  ]);

  return (
    <div className="w-full flex flex-col gap-8 bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border border-border-light-mode dark:border-border-dark-mode mb-4">
      <FormContainer title="Informações Gerais" arrangement="fullRow" gap="small">
        <>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-2 items-center">
            <DefaultFormRadioGroupInput
              name='ativo'
              label='Ativo'
              options={ativoOptions}
              reactHookForm={hookForm}
            />

            <DefaultFormDatePickerInput
              name="dataCadastro"
              label="Data de Cadastro"
              reactHookForm={hookForm}
            />
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
            <DefaultFormInput
              name="codigo"
              label="Código"
              required
              reactHookForm={hookForm}
            />

            <DefaultFormAutocomplete
              name="idCentroCusto"
              label="Centro de Custo"
              getOptionKey={x => x.id}
              getOptionLabel={x => x.title}
              options={centroCustoDropdown}
              reactHookForm={hookForm}
            />
          </div>

          <DefaultFormInput
            name="descricao"
            label="Nome do Patrimônio"
            required={true}
            multiline={true}
            rows={5}
            reactHookForm={hookForm}
          />

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
            <DefaultFormInput
              name="criterioAceitacao"
              label="Critério de Aceitação"
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name="referenciaAceitacao"
              label="Referência de Aceitação"
              reactHookForm={hookForm}
            />
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-2">
            <FormMaskedInput
              name="quantidade"
              label="Quantidade"
              mask="00000"
              maskPlaceholder="_____"
              reactHookForm={hookForm}
            />

            <FormDatePickerInput
              name="dataAquisicao"
              label="Data da Aquisição"
              reactHookForm={hookForm}
            />

            <FormDatePickerInput
              name="dataGarantia"
              label="Data da Garantia"
              reactHookForm={hookForm}
            />
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-2 items-center">
            <DefaultFormRadioGroupInput
              name="tipoCalibradoMonit"
              label="Calibrado / Verificado Por"
              options={tipoOptions}
              reactHookForm={hookForm}
              onChangeValue={value => {
                hookForm.setValue('idFornecedorMonit', null);
                hookForm.setValue('idFuncionarioMonit', null);
                hookForm.setValue('descResponsavelMonit', null);
              }}
            />

            <div className="flex flex-col">
              <div className="w-full h-[2.8rem]">
                {
                  (tipoCalibradoMonit === 1 && preencherRespCal === false) && (
                    <DefaultFormAutocomplete
                      name="idFornecedorMonit"
                      label="Fornecedor"
                      getOptionKey={x => x.idFornecedor}
                      getOptionLabel={x => x.nomeFantasia}
                      options={fornecedorDropdown}
                      reactHookForm={hookForm}
                    />
                  )
                }
                {
                  (tipoCalibradoMonit === 0 && preencherRespCal === false) && (
                    <DefaultFormAutocomplete
                      name="idFuncionarioMonit"
                      label="Funcionário"
                      getOptionDisabled={x => !x.canBeSelected}
                      getOptionKey={x => x.idFuncionario}
                      getOptionLabel={x => x.nome}
                      options={funcionarioMonitDropdown}
                      reactHookForm={hookForm}
                    />
                  )
                }
                {
                  preencherRespCal === true && (
                    <DefaultFormInput
                      name="descResponsavelMonit"
                      label="Responsável"
                      reactHookForm={hookForm}
                    />
                  )
                }
              </div>

              <DefaultFormCheckBox
                name="preencherRespCal"
                label="Preencher o responsável"
                reactHookForm={hookForm}
                onChangeValue={_ => {
                  hookForm.setValue('idFornecedorMonit', null);
                  hookForm.setValue('idFuncionarioMonit', null);
                  hookForm.setValue('descResponsavelMonit', null);
                }}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-2 items-center">
            <DefaultFormRadioGroupInput
              name="tipoMonitoramento"
              label="Tipo Monitoramento"
              options={monitoramentoOptions}
              reactHookForm={hookForm}
            />

            <div className="flex flex-col">
              <div className="w-full h-[2.8rem]">
                {
                  preencherRespResp === false && (
                    <DefaultFormAutocomplete
                      name="idFuncionarioResp"
                      label="Responsável pelo Equipamento"
                      getOptionDisabled={x => !x.canBeSelected}
                      getOptionKey={x => x.idFuncionario}
                      getOptionLabel={x => x.nome}
                      options={funcionarioRespDropdown}
                      reactHookForm={hookForm}
                    />
                  )
                }
                {
                  preencherRespResp === true && (
                    <DefaultFormInput
                      name="descResponsavelResp"
                      label="Responsável pelo Equipamento"
                      reactHookForm={hookForm}
                    />
                  )
                }
              </div>

              <DefaultFormCheckBox
                name="preencherRespResp"
                label="Preencher o responsável"
                reactHookForm={hookForm}
                onChangeValue={_ => {
                  hookForm.setValue('idFuncionarioResp', null);
                  hookForm.setValue('descResponsavelResp', null);
                }}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-2">
            <div className="w-full flex flex-col">
              <FormMaskedInput
                name="frequenciaVerificacao"
                label="Frequência"
                mask={"00000"}
                maskPlaceholder="_____"
                reactHookForm={hookForm}
              />

              <span className="text-gray-500 dark:text-gray-400 text-sm mb-2">
                Informe o número de dias
              </span>
            </div>

            <FormDatePickerInput
              name="dataVerificacao"
              label="Data Calibração/Verificação"
              reactHookForm={hookForm}
            />

            <FormDatePickerInput
              name="dataProxVerificacao"
              label="Data da Próxima calibração"
              readOnly={true}
              reactHookForm={hookForm}
            />
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-2">
            <DefaultFormInput
              name="marca"
              label="Marca"
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name="modelo"
              label="Modelo"
              reactHookForm={hookForm}
            />

            <DefaultFormMoneyInput
              name="valor"
              label="Valor"
              reactHookForm={hookForm}
            />
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-2">
            <DefaultFormInput
              name="tipo"
              label="Tipo"
              reactHookForm={hookForm}
            />

            <DefaultFormAutocomplete
              name="idFornecedor"
              label="Fornecedor"
              getOptionKey={x => x.idFornecedor}
              getOptionLabel={x => x.nomeFantasia}
              options={fornecedorDropdown}
              reactHookForm={hookForm}
            />

            <DefaultFormSelectInput
              name="fatorGerador"
              label="Fator Gerador"
              showSelectionLabel={false}
              options={fatorGeradorOptions}
              reactHookForm={hookForm}
            />
          </div>

          <DefaultFormSelectInput
            name="status"
            label="Status"
            showSelectionLabel={false}
            options={statusOptions}
            reactHookForm={hookForm}
          />

          <DefaultFormInput
            name="faixaDeUso"
            label="Faixa de Uso"
            multiline={true}
            rows={2}
            reactHookForm={hookForm}
          />

          <DefaultFormInput
            name="localizacao"
            label={"Localização"}
            multiline={true}
            rows={2}
            reactHookForm={hookForm}
          />

          <DefaultFormInput
            name="observacao"
            label={"Observações"}
            multiline={true}
            rows={6}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </div>
  );
}
